import { LuCircleCheckBig } from "react-icons/lu";
import { TbAlertTriangle } from "react-icons/tb";
import { ToastOptions, ToastPromiseParams, toast } from "react-toastify";

import { Toast } from "./toast";
import { ErrorData } from "./types";

export const notifyError = (
  message: string,
  _description?: string,
  options?: ToastOptions<ErrorData>
) => {
  return toast.error(
    <Toast
      className="text-pink-lemonade"
      icon={TbAlertTriangle}
      style={{
        backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),radial-gradient(76.6% 100% at 50% 100%, rgba(237, 34, 38, 0.4) 0%, rgba(237, 34, 38, 0.2) 100%)`,
        boxShadow: `0px 1px 1px 0px #ED222640 inset`,
      }}
      message={message}
    />,
    options
  );
};

export const notifySuccess = (message: string, options?: ToastOptions) => {
  return toast.success(
    <Toast
      message={message}
      icon={LuCircleCheckBig}
      className="text-spearmint"
      style={{
        backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), radial-gradient(76.6% 100% at 50% 100%, rgba(34, 237, 78, 0.4) 0%, rgba(34, 237, 78, 0.2) 100%)`,
        boxShadow: "0px 1px 1px 0px #22ED4E40 inset",
      }}
    />,
    options
  );
};

export const notifyPromise = <T,>(
  promise: Promise<T>,
  promiseParams: ToastPromiseParams<T>,
  options?: ToastOptions<T>
) => {
  return toast.promise<T>(promise, promiseParams, options);
};

export const notify = (message: string, options?: ToastOptions) => {
  return toast(message, options);
};
